// extracted by mini-css-extract-plugin
export default {"cta":"f4","grey":"g4","dark":"h4","chip":"i4","card":"j4","nonclickable":"k4","top":"l4","left":"m4","span":"n4","name":"o4"};
    if(module.hot) {
      // 1713361655591
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  